import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CatalogueComponent } from './catalogue/catalogue.component';

@NgModule({
  imports: [
    CommonModule
  ],
  exports:[CatalogueComponent],
  declarations: [CatalogueComponent]
})
export class CatalogueModule { }



// WEBPACK FOOTER //
// ./src/app/component/catalogue/catalogue.module.ts